import { Calendar } from "./Calendar";
import { useState } from "react";

export const Dashboard = () => {
    const [calendarView] = useState('month');

    return(
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
            <div className="md:flex md:items-center md:justify-between mb-8">
                <div className="flex-1 min-w-0">
                    <h2 className="text-2xl font-bold leading-7 text-gray-900 sm:text-3xl sm:tracking-tight">
                        Welcome to the Form System
                    </h2>
                    <p className="mt-1 text-sm text-gray-500">
                        If you experience issues, please contact IT.
                    </p>
                </div>
                <div className="mt-4 flex md:mt-0 md:ml-4">
                    <a href="/home/form" className="ml-3 inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500">
                        Create Event Request
                    </a>
                    <a href="/home/save-the-date" className="ml-3 inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-yellow-600 hover:bg-yellow-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-500">
                        Save the Date
                    </a>
                </div>
            </div>
            
            <div className="bg-white shadow sm:rounded-lg">
                <div className="px-4 py-5 sm:p-6">
                    <h3 className="text-lg font-medium leading-6 text-gray-900">
                        Approved Events Calendar
                    </h3>
                    <div className="mt-5">
                        <div className="bg-white overflow-hidden shadow rounded-lg">
                            <Calendar viewType={calendarView} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};